import { RelationEmpty, RelationSchema } from "$lib/data/schema/_relation"
import { z } from "zod/v4"

const ProductSchema = z.object({
  id: z.number().default(0),
  number: z.string().default(""),
  name: z.string().default(""),
  contents: z.array(z.string()).default([]),
  description: z.string().default(""),
  discount_percentage: z.number().default(0),
  price_currency: z.string().default(""),
  price_raw: z.number().default(0),
  price: z.number().default(0),
  unit: RelationSchema.default(RelationEmpty),
  image_url: z.string().default(""),
  status: z.boolean().default(false),
})
export type Product = z.infer<typeof ProductSchema>
export const ProductEmpty = ProductSchema.parse({})
